import { CdkConnectedOverlay } from '@angular/cdk/overlay';
import { Directive } from '@angular/core';
import { WindowRef } from '@x/common/browser';
import { ResponsiveService } from '@x/common/responsive';
import { filter, map } from 'rxjs/operators';

@Directive({
  selector: '[xOverlayResponsiveHeight]',
  exportAs: 'xOverlayResponsiveHeight',
})
export class OverlayResponsiveHeightDirective {
  height$ = this.overlay.positionChange.pipe(
    filter(() => this.responsiveService.isBreakpoint({ max: 'MD' })),
    filter(() => Boolean(this.windowRef.window?.innerHeight)),
    map(() => this.overlay),
    map((overlay) => {
      try {
        const overlayElement = overlay.overlayRef.overlayElement;
        const topPosition = overlayElement.getBoundingClientRect().top;

        return (this.windowRef.window?.innerHeight as number) - topPosition;
      } catch (e) {
        return '';
      }
    }),
  );

  constructor(
    private overlay: CdkConnectedOverlay,
    private responsiveService: ResponsiveService,
    private windowRef: WindowRef,
  ) {}
}
